const format = (endpoint: string) =>
  `${process.env.REACT_APP_BASE_URL}/${endpoint}`;

const endpoints = {
  login: format("admin/user/login"),
  merge: {
    index: format("admin/merge/"),
    car: format("admin/merge/car/"),
    submit: format("admin/merge/submit/"),
    sync: {
      brand: format("admin/merge/sync/brand/"),
      part: format("admin/merge/sync/part/"),
    },
    product: format("admin/merge/product/"),
  },
  address: {
    index: format("admin/address/"),
    basic: format("admin/address/basic/"),
    states: format("address/states/"),
  },
  user: {
    index: format("user/"),
    single: format("admin/user/single/"),
    findBy: format("admin/user/findBy/"),
    basic: format("admin/user/basic/"),
    medias: format("user/medias/"),
    active: format("user/status/"),
    workerOff: format("user/workerOff"),
    access: format("admin/user/access/"),
  },
  access: {
    index: format("admin/access/"),
    basic: format("admin/access/basic/"),
    single: format("admin/access/single/"),
  },
  role: {
    index: format("admin/role/"),
    basic: format("admin/role/basic/"),
    access: format("admin/role/access/"),
    single: format("admin/role/single/"),
  },
  category: {
    index: format("admin/category/"),
    old: format("admin/category/old/"),
    media: format("admin/category/medias/"),
    single: format("admin/category/single/"),
    basic: format("admin/category/basic/"),
  },
  tag: format("admin/tag/"),
  order: {
    index: format("admin/order/"),
    basic: format("admin/order/basic/"),
    factor: format("admin/order/factor/"),
    products: format("admin/order/products/"),
    delivery: format("admin/order/delivery/"),
    payment: format("admin/order/payment/"),
    callPrice: format("admin/order/callPrice/"),
    status: format("admin/order/status/"),
    single: format("admin/order/single/"),
    bijack: format("admin/order/bijack/"),
    relatedWorkers: format("order/relatedWorkers"),
    assign: format("order/assign"),
  },
  orderProduct: {
    index: format("admin/orderProduct/"),
    single: format("admin/orderProduct/single/"),
    variants: format("admin/orderProduct/variant/"),
    buy: format("admin/orderProduct/buy/"),
    buyer: format("admin/orderProduct/buyer/"),
    update: format("admin/orderProduct/update/"),
    review: format("admin/orderProduct/review/"),
  },
  product: {
    single: format("admin/product/single/"),
    basic: format("admin/product/basic/"),
    index: format("admin/product/"),
    awaitCommerce: format("admin/product/awaitingCommerce"),
    price: format("admin/product/price/"),
    specifics: format("admin/product/specifics/"),
    attributes: format("admin/product/attributes/"),
    fitFors: format("admin/product/fitFors/"),
    redirect: format("admin/product/redirect/"),
    relations: format("admin/product/relations/"),
    medias: format("admin/product/media/"),
    search: format("admin/product/search/"),
    inventory: format("admin/product/inventory/"),
    prices: format("admin/product/prices"),
    cardex: format("admin/product/cardex/"),
    cardexDescription: (id: number) => format(`admin/product/cardex/${id}/description`),
    cardexDelete: (id: number) => format(`admin/product/cardex/${id}`),
  },
  priceList: {
    index: format("admin/priceList"),
    basic: format("admin/priceList/basic/"),
    delete: (id: number) => format(`admin/priceList/${id}`),
    items: (id: number) => format(`admin/priceList/${id}/items`),
    prices: (id: number) => format(`admin/priceList/${id}/prices`),
    users: (id: number) => format(`admin/priceList/${id}/users`),
    removeUser: (id: number, userId: number) => format(`admin/priceList/${id}/users/${userId}`),
  },
  part: {
    index: format("admin/part/"),
    old: format("admin/part/old/"),
    single: format("admin/part/single/"),
    basic: format("admin/part/basic/"),
    specific: format("admin/part/specifics/"),
  },
  landing: {
    index: format("admin/landing/"),
    carLanding: format("admin/landing/carLanding/"),
    carLandingBasic: format("admin/landing/carLanding/basic/"),
    single: format("admin/landing/single/"),
    basic: format("admin/landing/basic/"),
    banners: format("admin/landing/banners/"),
    posts: format("admin/landing/posts/"),
    brands: format("admin/landing/brands/"),
    productGroups: format("admin/landing/productGroups/"),
  },
  brand: {
    index: format("admin/brand/"),
    basic: format("admin/brand/basic/"),
    single: format("admin/brand/single/"),
    medias: format("admin/brand/medias/"),
  },
  deliveryMethod: {
    index: format("admin/deliveryMethod/"),
    basic: format("admin/deliveryMethod/basic/"),
    single: format("admin/deliveryMethod/single/"),
  },
  paymentMethod: {
    index: format("admin/paymentMethod/"),
    basic: format("admin/paymentMethod/basic/"),
    single: format("admin/paymentMethod/single/"),
  },
  page: {
    index: format("admin/page/"),
    basic: format("admin/page/basic/"),
    single: format("admin/page/single/"),
    banners: format("admin/page/banners/"),
    brands: format("admin/page/brands/"),
    posts: format("admin/page/posts/"),
    productGroups: format("admin/page/productGroups/"),
  },
  color: {
    index: format("admin/color/"),
    basic: format("admin/color/basic/"),
    single: format("admin/color/single/"),
  },
  specificValue: {
    index: format("admin/specificValue/"),
    old: format("admin/specificValue/old/"),
  },
  car: {
    index: format("admin/car/"),
    basic: format("admin/car/basic/"),
    media: format("admin/car/medias/"),
  },
  store: {
    index: format("admin/store/"),
    basic: format("admin/store/basic/"),
  },
  variant: {
    index: format("admin/variant/"),
  },
  year: format("admin/year/"),
  specific: {
    index: format("admin/specific/"),
    single: format("admin/specific/single/"),
    old: format("admin/specific/old/"),
    basic: format("admin/specific/basic/"),
    value: format("admin/specific/value/"),
  },
  analytics: {
    overview: format("admin/dashboard/analytics/overview"),
    users: format("admin/dashboard/analytics/users"),
    userDetail: format("admin/dashboard/analytics/users/"),
    orders: format("admin/dashboard/analytics/orders"),
    products: format("admin/dashboard/analytics/products"),
    productDetail: format("admin/dashboard/analytics/products/"),
  },
  sms: {
    users: format("admin/sms/users"),
    send: format("admin/sms/send"),
  },
  notification: {
    users: format("admin/notification/users"),
    send: format("admin/notification/send"),
    list: format("admin/notification/list"),
  },
};
export default endpoints;
